import moment from 'moment';
import React from 'react';

const Details = (props: any) => (
  <React.Fragment>
    <div className={props.classes.rowValues}>
      <h4>Detalhes da fatura</h4>

      <div className='content__values'>
        <div className='value'>
          <div className='value__title'>Status</div>
          {props.invoice.payment_status && props.invoice.payment_status.name}
        </div>

        <div className='value'>
          <div className='value__title'>Codigo</div>
          {props.invoice.id}
        </div>

        {props.invoice.created_at && (
          <div className='value'>
            <div className='value__title'>Criação</div>
            {moment(props.invoice.created_at).format('L')}
          </div>
        )}

        {props.invoice.received_at && (
          <div className='value'>
            <div className='value__title'>Pagamento</div>
            {moment(props.invoice.received_at).format('L')}
          </div>
        )}

        <div className='value'>
          <div className='value__title'>Crédito</div>
          {props.invoice.credited_at ? moment(props.invoice.credited_at).format('L') : '-'}
        </div>

        <div className='value'>
          <div className='value__title'>Vencimento</div>
          {props.invoice.expired_at && moment(props.invoice.expired_at).format('L')}
        </div>
        {props.invoice.payment_status && props.invoice.payment_status.id === 7 && (
          <div className='value'>
            <div className='value__title'>Reembolso</div>
            {props.invoice.refunded_at && moment(props.invoice.refunded_at).format('L')}
          </div>
        )}
      </div>
    </div>
  </React.Fragment>
);

export default Details;
